module.exports = __webpack_public_path__ + "app/images/about/Katie-Casey.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/about/Katie-Casey.jpg
// module id = 480
// module chunks = 0